module.exports = __webpack_public_path__ + "img/export.65d93b97.svg";